import { atom } from 'jotai';
import { TModal } from 'types/apis/modal';

export const modalAtom = atom({
  isOpen: false,
  isConfirm: false,
  title: '',
  text: '',
  element: undefined,
  cancelBtnText: '',
  submitBtnText: '',
  location: '',
  onClickBtn: undefined,
  onClickOutside: undefined,
  onCancel: undefined,
  onSubmit: undefined,
  modalStack: [] as TModal[],
});
